import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-callback',
  template: '', // optional: "Signing you in..."
})
export class CallbackComponent implements OnInit {
  constructor(private router: Router) {}

  async ngOnInit() {
    await this.router.navigateByUrl('/');
  }
}
